<div>
	<lib-card [isForm]="true" [title]="'Change password'">
		<ui-password-form-field
			[title]="'Password'"
			[isRequired]="true"
			[valueAsSignal]="form.password"
		></ui-password-form-field>

		<ui-form-save-button [saveHandler]="saveHandler()" [logHandler]="formLogHandler()"></ui-form-save-button>
	</lib-card>
</div>
